import React, { Component } from 'react'
import { Animated, StyleSheet, View } from 'react-native'
import TagList from './TagList'
import store from '../../../redux/store'
import { colors } from '../../styles/global'
import BackButton from './BackButton'
import SharedHelper from '../../../utils/SharedHelper'
import DVHamburgButton from '../../UIControls/DVHamburgButton'
import NoteTitleEdition from './NoteTitleEdition'
import NoteTitlePresentation from './NoteTitlePresentation'
import { DV_TAB_NOTE_CHAT, DV_TAB_NOTE_EDITOR } from '../../../utils/TabNavigationConstants'
import BotLine from '../../ChatsView/ChatDV/BotLine/BotLine'
import { updateNoteTitle } from '../../../utils/backends/Notes/notesFirestore'

export default class Header extends Component {
    constructor(props) {
        super(props)

        const storeState = store.getState()

        this.state = {
            selectedTab: storeState.selectedNavItem,
            isMiddleScreen: storeState.isMiddleScreen,
            mobile: storeState.smallScreenNavigation,
            loggedUser: storeState.loggedUser,
            taskTitleInEditMode: storeState.taskTitleInEditMode,
            editionMode: false,
            unsubscribe: store.subscribe(this.updateState),
        }
    }

    getMaxHeight = () => {
        const { editionMode, selectedTab } = this.state
        return (selectedTab === DV_TAB_NOTE_CHAT || selectedTab === DV_TAB_NOTE_EDITOR) && !editionMode ? 64 : 350
    }

    openTitleEdition = () => {
        this.setState({ editionMode: true })
    }

    closeTitleEdition = () => {
        this.setState({ editionMode: false })
    }

    render() {
        const {
            projectId,
            note,
            assistantId,
            setAssistantId,
            navigation,
            isFullscreen,
            disabled,
            setFullscreen,
            onOpenSideChat,
        } = this.props
        const { mobile, isMiddleScreen, loggedUser, editionMode, selectedTab } = this.state
        const accessGranted = SharedHelper.accessGranted(loggedUser, projectId)
        const maxHeight = this.getMaxHeight()
        const compactSharedChat = isFullscreen && selectedTab === DV_TAB_NOTE_CHAT && !accessGranted

        return (
            <Animated.View
                style={[
                    mobile
                        ? localStyles.containerMobile
                        : isMiddleScreen
                          ? localStyles.containerTablet
                          : localStyles.container,
                    isFullscreen && localStyles.containerFS,
                    compactSharedChat && localStyles.sharedChatContainer,
                ]}
            >
                <View
                    style={[
                        localStyles.upperHeader,
                        isFullscreen
                            ? selectedTab === DV_TAB_NOTE_CHAT
                                ? { paddingBottom: compactSharedChat ? 8 : 16 }
                                : localStyles.upperHeaderFS
                            : null,
                    ]}
                >
                    {/* Compact navigation can be active even above the middle-screen breakpoint. */}
                    {(mobile || isMiddleScreen) && accessGranted && (
                        <View style={localStyles.backButtonMobile}>
                            <BackButton projectId={projectId} note={note} />
                        </View>
                    )}

                    {mobile && loggedUser.isAnonymous && (
                        <View style={localStyles.backButtonMobile}>
                            <DVHamburgButton navigation={navigation} />
                        </View>
                    )}

                    <View style={[localStyles.titleContainer, { maxHeight: maxHeight }]}>
                        {editionMode ? (
                            <NoteTitleEdition
                                projectId={projectId}
                                note={note}
                                onSubmit={title => {
                                    updateNoteTitle(projectId, note.id, title, note)
                                }}
                                numberOfLines={10}
                                closeTitleEdition={this.closeTitleEdition}
                            />
                        ) : (
                            <NoteTitlePresentation
                                projectId={projectId}
                                openTitleEdition={this.openTitleEdition}
                                note={note}
                                disabled={!accessGranted || disabled}
                                hideLastEdited={isFullscreen}
                                maxHeight={maxHeight}
                            />
                        )}
                    </View>
                </View>

                {!isFullscreen && accessGranted && (
                    <View style={localStyles.bottomHeader}>
                        <TagList
                            projectId={projectId}
                            note={this.props.note}
                            assistantId={assistantId}
                            setAssistantId={setAssistantId}
                            disabled={disabled}
                            updateObjectState={this.props.updateObjectState}
                            onOpenSideChat={onOpenSideChat}
                        />
                    </View>
                )}
                {isFullscreen && selectedTab === DV_TAB_NOTE_CHAT && accessGranted && (
                    <View style={localStyles.bottomHeader}>
                        <BotLine
                            setFullscreen={setFullscreen}
                            objectId={note.id}
                            assistantId={assistantId}
                            setAssistantId={setAssistantId}
                            projectId={projectId}
                            objectType={'notes'}
                        />
                    </View>
                )}
            </Animated.View>
        )
    }

    componentWillUnmount() {
        if (this.state && this.state.unsubscribe) {
            this.state.unsubscribe()
        }
    }

    updateState = () => {
        const storeState = store.getState()

        this.setState({
            selectedTab: storeState.selectedNavItem,
            mobile: storeState.smallScreenNavigation,
            loggedUser: storeState.loggedUser,
            isMiddleScreen: storeState.isMiddleScreen,
            photoURL: storeState.assignee.photoURL,
            taskTitleInEditMode: storeState.taskTitleInEditMode,
        })
    }
}

const localStyles = StyleSheet.create({
    container: {
        minHeight: 140,
        flexDirection: 'column',
        justifyContent: 'space-between',
        paddingBottom: 24,
        marginHorizontal: 104,
    },
    containerTablet: {
        flexDirection: 'column',
        justifyContent: 'space-between',
        marginHorizontal: 56,
    },
    containerMobile: {
        flexDirection: 'column',
        justifyContent: 'space-between',
    },
    containerFS: {
        minHeight: 80,
        paddingBottom: 0,
    },
    sharedChatContainer: {
        minHeight: 0,
    },
    titleContainer: {
        marginRight: 'auto',
        flex: 1,
        maxHeight: 350,
        overflowY: 'hidden',
    },
    upperHeader: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        paddingBottom: 32,
    },
    upperHeaderFS: {
        paddingBottom: 0,
    },
    bottomHeader: {
        flexDirection: 'row',
    },
    userImage: {
        backgroundColor: colors.Text03,
        height: 24,
        width: 24,
        borderRadius: 100,
        marginRight: 8,
    },
    backButtonMobile: {
        left: -16,
    },
    backButtonTablet: {
        left: -16,
    },
})
